import { initImmersiveOnboarding as initLegacyOnboarding } from 'common/onboarding/immersive-onboarding-legacy';
import { initImmersiveOnboarding as initDocsOnboarding } from 'common/onboarding/immersive-onboarding';
interface ImmersiveOnboardingOptions {
  useDocsOnboarding?: boolean;
}
export const initImmersiveOnboardingInitializer = (options?: ImmersiveOnboardingOptions) => {
  const {
    useDocsOnboarding = false
  } = options || {};
  return useDocsOnboarding ? initDocsOnboarding() : initLegacyOnboarding();
};